import React from "react";

const Input = ({ type, label, bold, placeholder, preventPaste, value, setValue, disabled, errors, name, errorMessage, style = {} }) => {

    return (<div style={{ ...style }}>
        <label style={{ display: 'flex', marginTop: bold ? '25px' : '15px', fontWeight: bold ? '800' : '400', fontSize: '14px', color: '#000' }}>{label || ''}</label>
        <input onPaste={(e) => { preventPaste && e.preventDefault(); return false }} autoComplete="false" disabled={!!disabled} className={errors.includes(name) ? 'error' : ''} type={type} placeholder={placeholder || ''} value={value} onChange={(e) => setValue(e.target.value)} />
        {errorMessage && <p style={{ margin: 0, fontSize: '12px', color: 'red' }}>{errorMessage}</p>}
    </div>)

}

export default Input